import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'utils/axios';

export const getAllBusinessRules = createAsyncThunk(
  'businessRules/getAllBusinessRules',
  async ({ page = 1, type }, thunkAPI) => {
    try {
      const response = await axiosInstance.get(`/business-rules?limit=10&page=${page}&code_name=${type}`);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

export const getBusinessRuleById = createAsyncThunk('businessRules/getBusinessRuleById', async (id, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/business-rules/${id}`);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const editBusinessRuleById = createAsyncThunk(
  'businessRules/editBusinessRuleById',
  async (payload, thunkAPI) => {
    const { id, data } = payload;

    try {
      const response = await axiosInstance.put(`/business-rules/${id}`, { ...data });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

export const deleteBusinessRule = createAsyncThunk('businessRules/deleteBusinessRule', async (id, thunkAPI) => {
  try {
    const response = await axiosInstance.delete(`/business-rules/${id}`);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const createBusinessRule = createAsyncThunk('businessRules/createBusinessRule', async (payload, thunkAPI) => {
  try {
    const response = await axiosInstance.post(`/business-rules`, payload);

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const getBusinessRuleFormula = createAsyncThunk('businessRules/getBusinessRuleFormula', async (_, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/formula-variables?page=1&limit=20`);

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const getServices = createAsyncThunk('businessRules/getServices', async (_, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/services`);

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});
